import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';

import styles from './VipGodsAndKings.module.css';

const VipGodsAndKingsJackpot: FC<StandardJackpotProps> = (props) => {
  const vipGodsAndKingsIcons = {
    panel: '/group_vip_gods_and_kings/panel',
    grand: '/group_vip_gods_and_kings/grand',
    major: '/group_vip_gods_and_kings/major',
    minor: '/group_vip_gods_and_kings/minor',
    mini: '/group_vip_gods_and_kings/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={vipGodsAndKingsIcons}
      className={styles.vipGodsAndKingsTheme}
    />
  );
};

export default memo(VipGodsAndKingsJackpot);
